import axios from "axios";

export const uploadVideoInChunks = async ({ sasUrl, file, onProgress }) => {
  const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  let uploadedBytes = 0;
  const blockIds = [];

  for (let i = 0; i < totalChunks; i++) {
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunk = file.slice(start, end);

    // Block ID MUST be base64
    const blockId = btoa(`block-${String(i).padStart(6, "0")}`);
    blockIds.push(blockId);

    await axios.put(
      `${sasUrl}&comp=block&blockid=${encodeURIComponent(blockId)}`,
      chunk,
      {
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type || "video/mp4",
        },
        transformRequest: [
          function (data, headers) {
            delete headers.Authorization;
            delete headers.authorization;
            return data;
          },
        ],
      }
    );

    uploadedBytes += chunk.size;
    onProgress(Math.round((uploadedBytes * 100) / file.size));
  }

  // Azure-valid XML (NO newlines!)
  const blockListXml =
    '<?xml version="1.0" encoding="utf-8"?>' +
    "<BlockList>" +
    blockIds.map((id) => `<Latest>${id}</Latest>`).join("") +
    "</BlockList>";

  await axios.put(`${sasUrl}&comp=blocklist`, blockListXml, {
    headers: {
      "Content-Type": "application/xml",
    },
  });

  return sasUrl.split("?")[0];
};
